import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO, MapDTO, LocationMarkerDTO, LocationCircleDTO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-form-field-map',
  templateUrl: './map-form-field.component.html',
  styleUrls: ['./map-form-field.component.scss'],
  standalone: false,
})
export class MapFormFieldComponent extends DataTypeComponent implements OnDestroy, OnInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  map: MapDTO;

  ngOnDestroy() {}

  ngOnInit(): void {
    if (this.data !== undefined) {
      this.map = this.data as MapDTO;
    }
  }

  mapClicked($event: any) {}

  markerDragEnd(marker: any, $event: any): void {}

  clickedMarker(label: any, index: number) {}
}
